<template>
    <el-dialog
        v-if="showPrintDialog"
        class="configPrintDialog"
        :visible="true"
        top="30px"
        width="450px"
        :show-close="false"
        title="价签打印"
    >
        <xx-detail-card
            :column="1"
            :data="prinDetailInfo"
            :title="''"
        />
        <el-form
            ref="printForm"
            :model="printForm"
            :rules="printFormRules"
            label-position="top"
        >
            <el-form-item
                prop="printer"
                label="打印机:"
            >
                <el-select
                    v-model="printForm.printer"
                    placeholder="请选择打印机"
                >
                    <el-option
                        v-for="item in printerList"
                        :key="item"
                        :label="item"
                        :value="item"
                    />
                </el-select>
                <xx-link
                    @click="handleClickDownloadPrintHelper"
                >
                    点击下载打印助手
                </xx-link>
            </el-form-item>
            <el-form-item
                prop="printQuantity"
                label="打印数量:"
            >
                <el-input
                    v-model="printForm.printQuantity"
                    placeholder="请输入打印数量"
                />
            </el-form-item>
            <el-form-item
                prop="printDate"
                label="选择日期:"
            >
                <template slot="label">
                    <span>请核实日期:</span>
                    <span class="red">(默认等于采购日期，如有疑问请联系采购负责人)</span>
                </template>
                <el-date-picker
                    v-model="printForm.printDate"
                    style="width: 100%;"
                    type="date"
                    placeholder="选择日期"
                    value-format="timestamp"
                    :disabled="isLimitPrintDate"
                />
            </el-form-item>
        </el-form>
        <div
            slot="footer"
            class="dialog-footer"
        >
            <el-button
                type="primary"
                :disabled="!(printForm.printer&&printForm.printQuantity&&+printForm.printQuantity>0)"
                @click="confimPrintByMtob"
            >
                确认打印
            </el-button>
            <el-button @click="onClickCancelDialog">
                取消
            </el-button>
        </div>
    </el-dialog>
</template>
<script>
import Rules from '@lsfe/rules';
import moment from 'moment';
import {
    MTOBClient, MTOBPrinter, ESDKEvents, ESDKStatus,
} from '@mtfe/mtob-client';
import { cookie, search } from '@lsfe/tools';
import { CODE_TYPE } from './constants';

export default {
    props: {
        showDialog: {
            type: Boolean,
            default: false,
        },
        prinDetailInfo: {
            type: Array,
            default: () => ([]),
        },
        currentRow: {
            type: Object,
            default: () => ({}),
        },
    },

    data() {
        const { printer } = search();
        return {
            isAtWhiteList: false,
            printerList: [],
            showPrintDialog: false,
            printFormRules: {
                printer: [
                    Rules.isRequired('请选择打印机'),
                ],
                printQuantity: [
                    Rules.isRequired('请输入数量'),
                    Rules.typeValid({ type: 'integer' }, '请填整数'),
                    {
                        validator: (rule, value, callback) => {
                            let max = 100;
                            // 命中两种白名单均增加到 1000
                            if (this.isAtWhiteList) max = 1000;
                            if (value < 1 || value > max) {
                                callback(new Error(`范围1-${max}`));
                            } else {
                                callback();
                            }
                        },
                        trigger: 'change',
                    },
                ],
                printDate: [
                    Rules.isRequired('请选择日期'),
                ],
            },
            printForm: {
                printer: printer || '',
                printQuantity: '',
                printDate: '',
            },
            isLimitPrintDate: false,
            supplierId: -1,
            supplierName: '',
            printTagTemplate: {
                0: '8ae03e9ecf1986b9f7729b8f30b5343e/enhanced.json',
                1: '8ae03e9ecf1986b9f7729b8f30b5343e/enhanced.json',
                2: '928ddc22346f0b35f5af58ed8125cfbe/enhanced.json',
                3: 'd72b52408cf1fc44d3dced2bc4294ff9/enhanced.json',
            },
            maxPrintDate: 7,
        };
    },

    watch: {
        showDialog: {
            handler(val) {
                if (val) {
                    this.initPrintForm();
                }
            },
            immediate: true,
        },
    },

    methods: {
        async getSupplierId() {
            const res = await this.__getSupplierInfoByBizAcountId();
            const { supplierId, name, code } = res || {};
            this.supplierId = supplierId;
            this.supplierName = name;
            this.supplierCode = code;
        },

        async getSupplierWhiteList() {
            const data = await this.$hGet('/api/m/vss/pms/check/supplierWhiteList', { supplierId: this.supplierId });
            this.isAtWhiteList = data;
        },

        async initPrintForm() {
            try {
                const { printDate } = this.currentRow;
                this.printForm.printDate = new Date(printDate || '');
                this.isLimitPrintDate = !!printDate;
                await this.getSupplierId();
                await this.getTemplateId();
                // await this.getSupplierWhiteList(); // 预采不需要供应商白名单
            } finally {
                this.initPrinter(() => {
                    this.showPrintDialog = true;
                });
            }
        },

        initPrinter(cb) {
            const loading = this.$loading({ lock: true, text: '打印助手建立连接中，请稍等...' });
            MTOBClient.on(ESDKEvents.StatusChange, async (args) => {
                if (args.status) {
                    loading.close();
                    cb();
                }
                if (args.status === ESDKStatus.READY) {
                    this.$message.success('打印助手建立连接成功');
                    try {
                        const list = await MTOBPrinter.getPrinterList();
                        this.printerList = list.map((item) => item.name);
                    } catch (e) {
                        this.$message.error(e.message);
                    }
                } else if (args.status === ESDKStatus.ERROR) {
                    this.$message.warning('打印助手建立连接超时或发送消息失败，请确保本地已启动 MTOB 客户端');
                } else if (args.status === ESDKStatus.DISCONNECTED) {
                    this.$message.warning('打印助手连接断开');
                } else if (args.status === ESDKStatus.MTOB_UPDATE_REQUIRED) {
                    this.$message.warning('客户端版本较低，正在自动更新，如果长时间未升级可手动下载打印助手');
                }
            });
            MTOBClient.init({
                appName: 'mall-fe-vss',
                env: process.env.NODE_ENV || 'test',
                projectId: 'mall-fe-vss',
            });
        },

        handleClickDownloadPrintHelper() {
            try {
                const downloadUrl = MTOBClient.getMTOBInfo().requiredVersionDownloadURL;
                this.$tools.download(downloadUrl || 'https://portal-portm.meituan.com/klfe/mtob/prod/downloadConfig?version=2.1.8');
            // eslint-disable-next-line no-empty
            } catch (e) {}
        },

        /**
         * vss肉禽蛋标签打印规则： 查询模板，模板id 为0  --->原来的逻辑不变 模板id为 1，2，3     使用新的逻辑
         * 1. 获取模板 （根据标签模板灰度）
         * 2. 生成code
         * 3. 获取标签内容
         */
        /**
         * 查询商品模板信息
         */
        async getSkuLableTemplate() {
            const { skuId, skuCode, poiId } = this.currentRow;
            const res = await this.$hPost('/shop/codecenter/barcode/type/query/vss', {
                source: 'VSS',
                poiId,
                skuId: +skuId,
                baseCode: skuCode,
                supplyCode: this.supplierCode, // 供货编码
                supplierId: this.supplierId,
            });
            return { ...res, templateTypeId: res.templateId } || {
                templateTypeId: 0,
                codeType: CODE_TYPE.NORMAL_CODE,
            };
        },

        getPrintData() {
            const { skuId, skuCode, poiId } = this.currentRow;
            const { printQuantity, printDate } = this.printForm;
            return this.$hPost('/api/m/vss/pms/query/skuPrintInfo', {
                skuId: +skuId,
                poiId: +poiId,
                skuCode,
                genQuantity: printQuantity,
                produceTime: +moment(printDate).startOf('day').format('x'),
                fromPreOrder: true, // 预采场景需设置为true
                supplierId: this.supplierId,
            });
        },

        formatPrintData(res) {
            const { printQuantity } = this.printForm;
            const originData = res || {};
            const isPcsCode = originData.isPcsCode;
            const {
                barCode, pcsCodes, layoutInfo, templateId, ...baseData
            } = originData;
            const items = layoutInfo.items || [];
            const priceInfos = items.reduce((prev, next) => {
                const { labelKey } = next;
                if (!prev[labelKey]) {
                    prev[labelKey] = {};
                    prev[labelKey].labelDesc = next.labelDesc;
                    prev[labelKey].labelValue = next.labelValue;
                }
                return prev;
            }, {});
            const hideCodeVal = (priceInfos.hideCode || {}).labelValue;
            const extraCode = hideCodeVal ? `Y${this.supplierCode}${hideCodeVal}` : `Y${this.supplierCode}`;

            const priceInfosRes = {
                ...priceInfos,
                extraCode,
            };
            // 如果是件码，每个价签的条形码是不一样的
            if (isPcsCode) {
                return pcsCodes.map((v) => ({
                    barCode: v,
                    ...baseData,
                    ...priceInfosRes,
                }));
            }

            // 24/27码的条形码都是一样的
            return new Array(+printQuantity).fill({ ...baseData, barCode, ...priceInfosRes });
        },

        formatMeatAndEggsPrintData(res) {
            const { printQuantity } = this.printForm;
            const {
                pcsCodes, storageRequirement, isPcsCode, hideCode, lableCodeList, ...baseData
            } = res;

            const extraCode = hideCode ? `Y${this.supplierCode}(${hideCode})` : `Y${this.supplierCode}`;

            // 如果是件码，每个价签的条形码是不一样的
            if (isPcsCode) {
                return pcsCodes.map((v) => ({
                    barCode: v,
                    ...baseData,
                    extraCode,
                    dateInfo: {},
                    customInfo: {},
                    storageRequirement,
                }));
            }
            return new Array(+printQuantity).fill({
                ...baseData,
                extraCode,
                dateInfo: {},
                customInfo: {},
                barCode: lableCodeList[0],
                storageRequirement,
            });
        },

        /**
         * 获取新的商品标签模版信息
         */
        async getMeatAndEggs(templateTypeId) {
            const { skuId, skuCode, poiId } = this.currentRow;
            const { printQuantity, printDate } = this.printForm;
            /**
             * 生成code
             */
            const printCode = await this.$hPost('/shop/codecenter/skucode/generate', {
                poiId: +poiId,
                isTest: false,
                source: 21, // 来源:1-米粒, 21-芥末vss, 22-芥末加工计划, 23-芥末加工记录, 24-芥末商品
                operator: cookie.get('msid'),
                skuCodeAndWeightList: [
                    {
                        skuId: +skuId,
                        code: skuCode,
                        // produceTime: printDate,
                        produceTime: +moment(printDate).startOf('day').format('x'),
                        printQuantity,
                    },
                ],
                supplierInfo: { supplierId: this.supplierId, supplierName: this.supplierName, templateTypeId },
                templateTypeId,
            });
            if (printCode) {
                const {
                    skuCodeList: [{
                        barcode,
                        skuName, // 商品名称
                        isPcsCode, // true：是件码；false：不是件码
                        pcsCodes, // 件码列表
                        actualSpec, // 规格
                        produceAreaName, // 产地
                        storageTemperatureLevelName, // 存储条件
                        productDate, // 生产日期-已转成标签上的格式
                        // isExtWeight,
                        weight,
                        price, // 元,散装称重有值
                        totalPrice, // 元,散装称重有值
                        isNormal, // true:标品,false:散装
                    }],
                } = printCode;
                const printData = await this.$hPost('/shop/codecenter/sku/lable', {
                    skuLableInfo: {
                        poiId: +poiId,
                        skuId: +skuId,
                        lableCodeList: isPcsCode ? pcsCodes : [barcode],
                        skuName,
                        actualSpec, // 实际规格
                        produceAreaName, // 产地
                        storageTemperatureLevelName, // 存储条件
                        productDate, // 生产日期-已转成标签上的格式
                        weight, // 重量,kg，有则返回
                        price, // 元,散装称重有值
                        totalPrice, // 元,散装称重有值
                        supplierId: this.supplierId,
                        isNormal,
                    },
                });
                return {
                    isPcsCode,
                    pcsCodes,
                    ...printData,
                };
            }
            return {};
        },

        async getTemplateId() {
            const isProd = ['beta', 'staging', 'production'].includes(process.env.NODE_ENV);
            const urlPrefix = '//portal-portm.meituan.com/horn/v1/modules';
            const apiName = isProd ? 'prod' : 'test';
            const url = [urlPrefix, 'vss', apiName].join('/');
            const res = await this.$get(url, {}, { parseData: false });
            const { printTagTemplate, maxPrintDate } = res;
            this.printTagTemplate = printTagTemplate;
            this.maxPrintDate = maxPrintDate;
        },

        /**
         * 日期码聚合生成码接口
         */
        async getDateCodePrintTag(templateTypeId, codeType) {
            const { skuId, skuCode, poiId } = this.currentRow;
            const { printQuantity, printDate } = this.printForm;
            const dateCodeTag = await this.$hPost('/shop/codecenter/barCode/generate/vss', {
                source: 'VSS',
                poiId: +poiId,
                operator: cookie.get('msid'),
                skuParams: {
                    skuId: +skuId,
                    baseCode: skuCode,
                    productDate: +moment(printDate).startOf('day').format('x'),
                    genQuantity: printQuantity,
                    codeType,
                },
                needLabelData: true,
                supplierName: this.supplierName,
                supplierId: this.supplierId,
                supplyCode: this.supplierCode,
                templateId: templateTypeId,
            });
            return dateCodeTag || {};
        },

        /**
         * 日期码标签格式化
         */
        formatDateCodePrintData(res) {
            const { printQuantity } = this.printForm;
            const { generateSkuCode: { codeType, barCodeList }, labelData: { hideCode }, labelData } = res;
            const extraCode = hideCode ? `Y${this.supplierCode}(${hideCode})` : `Y${this.supplierCode}`;

            // 如果是件码，每个价签的条形码是不一样的
            if (codeType === CODE_TYPE.PCS_CODE) {
                return barCodeList.map((v) => ({
                    barCode: v,
                    extraCode,
                    ...labelData,
                    dateInfo: {},
                    customInfo: {},
                }));
            }
            return new Array(+printQuantity).fill({
                ...labelData,
                extraCode,
                barCode: barCodeList[0],
                dateInfo: {},
                customInfo: {},
            });
        },

        /**
         * 新的打印获取，先生成code，再获取商品标签信息
         */
        async fetPrintTagContent() {
            const { templateTypeId, codeType } = await this.getSkuLableTemplate();
            let templateId = '8ae03e9ecf1986b9f7729b8f30b5343e/enhanced.json';
            const oldPrint = [0, 1];
            let printData = {};
            /**
             * 是这样 如果是26码 && 模版非0和1 走新接口，其他情况走老流程吧
             */
            if (oldPrint.includes(Number(templateTypeId))) {
                // 老逻辑打印
                printData = await this.getPrintData();
                this.tagPrintInfo = this.formatPrintData(printData);
            } else {
                templateId = this.printTagTemplate[templateTypeId];
                if (codeType === CODE_TYPE.DATE_CODE) {
                    printData = await this.getDateCodePrintTag(templateTypeId, codeType);
                    this.tagPrintInfo = this.formatDateCodePrintData(printData);
                } else {
                    printData = await this.getMeatAndEggs(templateTypeId);
                    this.tagPrintInfo = this.formatMeatAndEggsPrintData(printData);
                }
            }

            return {
                printData,
                templateId,
            };
        },

        async confimPrintByMtob() {
            try {
                await this.$refs.printForm.validate();
            } catch (e) {
                this.$message.error(e.message || '请根据错误提示修改');
                return;
            }
            const loading = this.$loading({ lock: true, text: '打印即将开始，请稍后...' });
            try {
                const { templateId } = await this.fetPrintTagContent();
                const options = {
                    printerName: this.printForm.printer,
                    templateId: templateId || '8ae03e9ecf1986b9f7729b8f30b5343e/enhanced.json',
                };
                try {
                    await MTOBPrinter.print(this.formatForMtob(this.tagPrintInfo), options);
                    this.$message.success('开始执行打印任务');
                    this.showPrintDialog = false;
                } catch (e) {
                    this.$message.error(`打印失败: ${e.message}`);
                } finally {
                    loading.close();
                }
            } catch (error) {
                this.$message.error(error.message || '打印接口报错');
            } finally {
                loading.close();
                this.$emit('cancel-dialog');
            }
        },

        onClickCancelDialog() {
            this.showPrintDialog = false;
            this.$emit('cancel-dialog');
        },

        formatForMtob(list) {
            return list.map((item) => ({
                ...item,
                dateInfoLabel: item.dateInfo.labelDesc,
                dateInfoValue: item.dateInfo.labelValue,
                customLabel: item.customInfo.labelDesc,
                customValue: item.customInfo.labelValue,
                logo: 'https://s3plus.meituan.net/mall-fe-files/newlog.png',
            }));
        },
    },
};
</script>
<style lang="scss" scoped>
.red {
    color: red;
}

 .configPrintDialog {
     /deep/ {
          .xx-form-panel .title {
            padding: 0;
        }
        .el-dialog__header {
            height: 0;
            .el-dialog__headerbtn {
                top: 0;
                right: 0;
                font-size: 20px;
            }
        }

}

    }
</style>
